import pythonProject from "./pythonProject";
export default [
	...pythonProject,
	{
		title: "首页",
		name: "index",
		grade: 1
	},
	{
		title: "支付",
		name: "payMethod",
		grade: 1
	},
	{
		title: "成绩单",
		name: "tranScript",
		grade: 1
	},
	{
		title: "完善地址信息",
		name: "fillAddress",
		grade: 1
	},
	{
		title: "登录",
		name: "login",
		grade: 1
	},
	{
		title: "开始答题",
		name: "accountTesting",
		grade: 1
	},
	{
		title: "选择科目",
		name: "accountStart",
		grade: 1
	},
	{
		title: "选择科目",
		name: "realProblemIndex",
		grade: 1
	},
	{
		title: "2018经济师考前必做200题！",
		name: "realProblem",
		grade: 1
	},
	{
		title: "选择科目",
		name: "teacherIndex",
		params: "teacherIndex/:id?",
		grade: 1
	},
	{
		title: "教师资格密押考题100道，每刷一题都在抢分",
		name: "teacherStart",
		grade: 1
	},

	{
		title: "选择科目",
		name: "teacherIndex2",
		params: "teacherIndex2/:id",
		grade: 1
	},
	{
		title: "教师资格考前必做100道题！",
		name: "teacherStart2",
		params: "teacherIndex2/teacherStart2/:id",
		grade: 1
	},
	{
		title: "选择科目",
		name: "teacherIndex3",
		params: "teacherIndex3/:id",
		grade: 1
	},
	{
		title: "教师资格考前必做100道题！",
		name: "teacherStart3",
		params: "teacherIndex3/teacherStart3/:id",
		grade: 1
	},

	{
		title: "选择科目",
		name: "fireControlIndex",
		grade: 1,
		params: "fireControlIndex/:id"
	},
	{
		title: "一级消防考前必做200道题！",
		grade: 1,
		params: "fireControlIndex/fireControlStart/:id",
		name: "fireControlStart"
	},
	{
		title: "选择科目",
		name: "changePage",
		grade: 1
	},
	{
		title: "测试",
		name: "testPage",
		grade: 1
	},
	{
		title: "土豪支付",
		name: "boostPay",
		grade: 1
	},

	// 测试支付
	{
		title: "必考100题目",
		paramsName: "mustDoIndex",
		params: "mustDoIndex/:id?",
		name: "mustDoSubject/mustDoIndex",
		grade: 1
	},

	// 必考100题目
	{
		title: "必考100题目",
		paramsName: "mustDoSubject",
		params: "mustDoSubject/:id?",
		name: "mustDoSubject/mustDoSubject",
		grade: 1
	},

	// 考前密卷
	{
		title: "2019执业/助理医师密押题",
		paramsName: "secretVolume",
		params: "secretVolume/:id?",
		name: "secretVolume/secretVolumeHome",
		grade: 1
	},
	{
		title: "2019执业/助理医师密押题",
		paramsName: "secretVolume",
		params: "textTypeHome/:id?",
		name: "secretVolume/textTypeHome",
		grade: 1
	},
	{
		title: "做题目",
		paramsName: "secretVolume",
		params: "textAnswerPage/:id?",
		name: "secretVolume/textAnswerPage",
		grade: 1
	},
	{
		title: "考点巩固",
		paramsName: "secretVolume",
		params: "testConsolidate/:id?",
		name: "secretVolume/testConsolidate",
		grade: 1
	},
	{
		title: "视频跟图片题型",
		paramsName: "secretVolume",
		params: "specialTypeHome/:id?",
		name: "secretVolume/specialTypeHome",
		grade: 1
	},
	{
		title: "助力解锁",
		paramsName: "secretVolume",
		params: "shareAssistance/:id?",
		name: "secretVolume/shareAssistance",
		grade: 1
	},

	// 商城
	{
		title: "详情",
		paramsName: "ShopCourseDetail",
		params: "ShopCourseDetail/:id?",
		name: "store/ShopCourseDetail",
		grade: 1
	},
	// 商城支付
	{
		title: "收银台",
		paramsName: "payPage",
		params: "payPage/:id?",
		name: "store/ShopCourseDetail/payPage",
		grade: 1
	},
	{
		title: "支付成功",
		paramsName: "StorePaySuccess",
		params: "StorePaySuccess/:id?",
		name: "store/ShopCourseDetail/components/StorePaySuccess",
		grade: 1
	},

	// 2019一级消防VIP口碑班
	{
		title: "2019一级消防VIP口碑班",
		name: "2019FireControlPay",
		grade: 1
	},
	{
		title: "支付成功",
		name: "2019FireControlPay/success",
		grade: 1
	},

	// 2019消防-考前密卷
	{
		title: "考前密训",
		paramsName: "fireSecret",
		params: "fireSecret/:id?",
		name: "fireSecret/fireSecretHome",
		grade: 1
	},
	{
		title: "考前密训",
		paramsName: "fireSecret",
		params: "firetextTypeHome/:id?",
		name: "fireSecret/textTypeHome",
		grade: 1
	},
	{
		title: "做题目",
		paramsName: "fireSecret",
		params: "firetextAnswerPage/:id?",
		name: "fireSecret/textAnswerPage",
		grade: 1
	},
	{
		title: "考点巩固",
		paramsName: "fireSecret",
		params: "firetestConsolidate/:id?",
		name: "fireSecret/testConsolidate",
		grade: 1
	},
	{
		title: "视频跟图片题型",
		paramsName: "fireSecret",
		params: "firespecialTypeHome/:id?",
		name: "fireSecret/specialTypeHome",
		grade: 1
	},
	{
		title: "助力解锁",
		paramsName: "fireSecret",
		params: "fireshareAssistance/:id?",
		name: "fireSecret/shareAssistance",
		grade: 1
	},
	// 2020执业药师-考前密卷
	{
		title: "2020执业/助理医师密押题",
		paramsName: "fireSecret",
		params: "2020pharmacistSecret/fireSecret/:id?",
		name: "2020pharmacistSecret/fireSecretHome",
		grade: 1
	},
	{
		title: "2020执业/助理医师密押题",
		paramsName: "fireSecret",
		params: "2020pharmacistSecret/firetextTypeHome/:id?",
		name: "2020pharmacistSecret/textTypeHome",
		grade: 1
	},
	{
		title: "2020执业/助理医师密押题",
		paramsName: "fireSecret",
		params: "2020pharmacistSecret/firetextAnswerPage/:id?",
		name: "2020pharmacistSecret/textAnswerPage",
		grade: 1
	},
	{
		title: "2020执业/助理医师密押题",
		paramsName: "fireSecret",
		params: "2020pharmacistSecret/firetestConsolidate/:id?",
		name: "2020pharmacistSecret/testConsolidate",
		grade: 1
	},
	{
		title: "2020执业/助理医师密押题",
		paramsName: "fireSecret",
		params: "2020pharmacistSecret/firespecialTypeHome/:id?",
		name: "2020pharmacistSecret/specialTypeHome",
		grade: 1
	},
	{
		title: "2020执业/助理医师密押题",
		paramsName: "fireSecret",
		params: "2020pharmacistSecret/fireshareAssistance/:id?",
		name: "2020pharmacistSecret/shareAssistance",
		grade: 1
	},
	// 2020会计考前密券
	{
		title: "初级会计考前密押200题",
		paramsName: "fireSecret",
		params: "2020accountSecret/fireSecret/:id?",
		name: "2020accountSecret/fireSecretHome",
		grade: 1
	},
	{
		title: "初级会计考前密押200题",
		paramsName: "fireSecret",
		params: "2020accountSecret/firetextTypeHome/:id?",
		name: "2020accountSecret/textTypeHome",
		grade: 1
	},
	{
		title: "初级会计考前密押200题",
		paramsName: "fireSecret",
		params: "2020accountSecret/firetextAnswerPage/:id?",
		name: "2020accountSecret/textAnswerPage",
		grade: 1
	},
	// 2021会计考前密券
	{
		title: "2026初级会计考前密押",
		paramsName: "fireSecret",
		params: "2021accountSecret/fireSecret/:id?",
		name: "2021accountSecret/fireSecretHome",
		grade: 1
	},
	{
		title: "2026初级会计考前密押",
		paramsName: "fireSecret",
		params: "2021accountSecret/firetextTypeHome/:id?",
		name: "2021accountSecret/textTypeHome",
		grade: 1
	},
	{
		title: "2026初级会计考前密押",
		paramsName: "fireSecret",
		params: "2021accountSecret/firetextAnswerPage/:id?",
		name: "2021accountSecret/textAnswerPage",
		grade: 1
	},
	// 2021中级会计考前密押
	{
		title: "中级会计考前密押",
		paramsName: "fireSecret",
		params: "2021accountSecretMiddle/fireSecret/:id?",
		name: "2021accountSecretMiddle/fireSecretHome",
		grade: 1
	},
	{
		title: "中级会计考前密押",
		paramsName: "fireSecret",
		params: "2021accountSecretMiddle/firetextTypeHome/:id?",
		name: "2021accountSecretMiddle/textTypeHome",
		grade: 1
	},
	{
		title: "中级会计考前密押",
		paramsName: "fireSecret",
		params: "2021accountSecretMiddle/firetextAnswerPage/:id?",
		name: "2021accountSecretMiddle/textAnswerPage",
		grade: 1
	},
	// 2022初级会计【决胜密押200题】
	{
		title: "2022决胜密押题",
		paramsName: "fireSecret",
		params: "2022accountSecretMiddle/fireSecret/:id?",
		name: "2022accountSecretMiddle/fireSecretHome",
		grade: 1
	},
	{
		title: "2022决胜密押题",
		paramsName: "fireSecret",
		params: "2022accountSecretMiddle/firetextTypeHome/:id?",
		name: "2022accountSecretMiddle/textTypeHome",
		grade: 1
	},
	{
		title: "2022决胜密押题",
		paramsName: "fireSecret",
		params: "2022accountSecretMiddle/firetextAnswerPage/:id?",
		name: "2022accountSecretMiddle/textAnswerPage",
		grade: 1
	},
	// 2020护士/护师考前密券
	{
		title: "2021决胜密押题公布",
		paramsName: "fireSecret",
		params: "2020accountSecrethusi/fireSecret/:id?",
		name: "2020accountSecrethusi/fireSecretHome",
		grade: 1
	},
	{
		title: "2021决胜密押题公布",
		paramsName: "fireSecret",
		params: "2020accountSecrethusi/firetextTypeHome/:id?",
		name: "2020accountSecrethusi/textTypeHome",
		grade: 1
	},
	{
		title: "2021决胜密押题公布",
		paramsName: "fireSecret",
		params: "2020accountSecrethusi/firetextAnswerPage/:id?",
		name: "2020accountSecrethusi/textAnswerPage",
		grade: 1
	},
	// 2022 护士-决胜密押题
	{
		title: "2022决胜密押题",
		paramsName: "fireSecret",
		params: "2022accountSecrethusi/fireSecret/:id?",
		name: "2022accountSecrethusi/fireSecretHome",
		grade: 1
	},
	{
		title: "2022决胜密押题",
		paramsName: "fireSecret",
		params: "2022accountSecrethusi/firetextTypeHome/:id?",
		name: "2022accountSecrethusi/textTypeHome",
		grade: 1
	},
	{
		title: "2022决胜密押题",
		paramsName: "fireSecret",
		params: "2022accountSecrethusi/firetextAnswerPage/:id?",
		name: "2022accountSecrethusi/textAnswerPage",
		grade: 1
	},

	// 2022护士/护师考前密券
	{
		title: "2023护理考前押题模考",
		paramsName: "fireSecret",
		params: "2022hushi/fireSecret/:id?",
		name: "2022hushi/fireSecretHome",
		grade: 1
	},
	{
		title: "2023护理考前押题模考",
		paramsName: "fireSecret",
		params: "2022hushi/firetextTypeHome/:id?",
		name: "2022hushi/textTypeHome",
		grade: 1
	},
	{
		title: "2023护理考前押题模考",
		paramsName: "fireSecret",
		params: "2022hushi/firetextAnswerPage/:id?",
		name: "2022hushi/textAnswerPage",
		grade: 1
	},

	// 2022护士/护师考前密券
	{
		title: "2023初级会计考前密押卷",
		paramsName: "fireSecret",
		params: "2023account/fireSecret/:id?",
		name: "2023account/fireSecretHome",
		grade: 1
	},
	{
		title: "2023初级会计考前密押卷",
		paramsName: "fireSecret",
		params: "2023account/firetextTypeHome/:id?",
		name: "2023account/textTypeHome",
		grade: 1
	},
	{
		title: "2023初级会计考前密押卷",
		paramsName: "fireSecret",
		params: "2023account/firetextAnswerPage/:id?",
		name: "2023account/textAnswerPage",
		grade: 1
	},

	// 2022二级建造师考试科目
	{
		title: "二建考试【决胜密押题】",
		paramsName: "fireSecret",
		params: "2022associateConstructor/fireSecret/:id?",
		name: "2022associateConstructor/fireSecretHome",
		grade: 1
	},
	{
		title: "二建考试【决胜密押题】",
		paramsName: "fireSecret",
		params: "2022associateConstructor/firetextTypeHome/:id?",
		name: "2022associateConstructor/textTypeHome",
		grade: 1
	},
	{
		title: "二建考试【决胜密押题】",
		paramsName: "fireSecret",
		params: "2022associateConstructor/firetextAnswerPage/:id?",
		name: "2022associateConstructor/textAnswerPage",
		grade: 1
	},

	// 2022二级初级护士
	{
		title: "2022急救押题卷",
		paramsName: "fireSecret",
		params: "2022hushiConstructor/fireSecret/:id?",
		name: "2022hushiConstructor/fireSecretHome",
		grade: 1
	},
	{
		title: "2022急救押题卷",
		paramsName: "fireSecret",
		params: "2022hushiConstructor/firetextTypeHome/:id?",
		name: "2022hushiConstructor/textTypeHome",
		grade: 1
	},
	{
		title: "2022急救押题卷",
		paramsName: "fireSecret",
		params: "2022hushiConstructor/firetextAnswerPage/:id?",
		name: "2022hushiConstructor/textAnswerPage",
		grade: 1
	},

	// 2020建造师新考前密券
	{
		title: "2026二建考试决胜密押题",
		paramsName: "fireSecret",
		params: "2020accountSecretjzs/fireSecret/:id?",
		name: "2020accountSecretjzs/fireSecretHome",
		grade: 1
	},
	{
		title: "2026二建考试决胜密押题",
		paramsName: "fireSecret",
		params: "2020accountSecretjzs/firetextTypeHome/:id?",
		name: "2020accountSecretjzs/textTypeHome",
		grade: 1
	},
	{
		title: "2026二建考试决胜密押题",
		paramsName: "fireSecret",
		params: "2020accountSecretjzs/firetextAnswerPage/:id?",
		name: "2020accountSecretjzs/textAnswerPage",
		grade: 1
	},
	// 2024建造师新考前密券
	{
		title: "一建考试冲刺密押题",
		paramsName: "fireSecret",
		params: "2024accountSecretjzs/fireSecret/:id?",
		name: "2024accountSecretjzs/fireSecretHome",
		grade: 1
	},
	{
		title: "一建考试冲刺密押题",
		paramsName: "fireSecret",
		params: "2024accountSecretjzs/firetextTypeHome/:id?",
		name: "2024accountSecretjzs/textTypeHome",
		grade: 1
	},
	{
		title: "一建考试冲刺密押题",
		paramsName: "fireSecret",
		params: "2024accountSecretjzs/firetextAnswerPage/:id?",
		name: "2024accountSecretjzs/textAnswerPage",
		grade: 1
	},
	// 2020药师考前密押卷
	{
		title: "2020执业药师考试决胜密押题",
		paramsName: "fireSecret",
		params: "2020accountSecretyaoshi/fireSecret/:id?",
		name: "2020accountSecretyaoshi/fireSecretHome",
		grade: 1
	},
	{
		title: "2020执业药师考试决胜密押题",
		paramsName: "fireSecret",
		params: "2020accountSecretyaoshi/firetextTypeHome/:id?",
		name: "2020accountSecretyaoshi/textTypeHome",
		grade: 1
	},
	{
		title: "2020执业药师考试决胜密押题",
		paramsName: "fireSecret",
		params: "2020accountSecretyaoshi/firetextAnswerPage/:id?",
		name: "2020accountSecretyaoshi/textAnswerPage",
		grade: 1
	},
	// 2021-04-02 药师密押题
	{
		title: "2021药学职称-决胜密押题",
		paramsName: "fireSecret",
		params: "2021accountSecretyaoshi/fireSecret/:id?",
		name: "2021accountSecretyaoshi/fireSecretHome",
		grade: 1
	},
	{
		title: "2021药学职称-决胜密押题",
		paramsName: "fireSecret",
		params: "2021accountSecretyaoshi/firetextTypeHome/:id?",
		name: "2021accountSecretyaoshi/textTypeHome",
		grade: 1
	},
	{
		title: "2021药学职称-决胜密押题",
		paramsName: "fireSecret",
		params: "2021accountSecretyaoshi/firetextAnswerPage/:id?",
		name: "2021accountSecretyaoshi/textAnswerPage",
		grade: 1
	},
	// 2020教师考前密押卷
	{
		title: "2021教师考试决胜密押题",
		paramsName: "fireSecret",
		params: "2020accountSecretjiaoshi/fireSecret/:id?",
		name: "2020accountSecretjiaoshi/fireSecretHome",
		grade: 1
	},
	{
		title: "2021教师考试决胜密押题",
		paramsName: "fireSecret",
		params: "2020accountSecretjiaoshi/firetextTypeHome/:id?",
		name: "2020accountSecretjiaoshi/textTypeHome",
		grade: 1
	},
	{
		title: "2021教师考试决胜密押题",
		paramsName: "fireSecret",
		params: "2020accountSecretjiaoshi/firetextAnswerPage/:id?",
		name: "2020accountSecretjiaoshi/textAnswerPage",
		grade: 1
	},
	// 2021护士前密押卷
	{
		title: "2021医疗事业单位护理招聘必刷500题",
		paramsName: "fireSecret",
		params: "2021accountSecrethushi/fireSecret/:id?",
		name: "2021accountSecrethushi/fireSecretHome",
		grade: 1
	},
	{
		title: "2021医疗事业单位护理招聘必刷500题",
		paramsName: "fireSecret",
		params: "2021accountSecrethushi/firetextTypeHome/:id?",
		name: "2021accountSecrethushi/textTypeHome",
		grade: 1
	},
	{
		title: "2021医疗事业单位护理招聘必刷500题",
		paramsName: "fireSecret",
		params: "2021accountSecrethushi/firetextAnswerPage/:id?",
		name: "2021accountSecrethushi/textAnswerPage",
		grade: 1
	},

	// 2021医师前密押卷 08-12
	{
		title: "考前密押200题",
		paramsName: "fireSecret",
		params: "2021accountSecretyishi/fireSecret/:id?",
		name: "2021accountSecretyishi/fireSecretHome",
		grade: 1
	},
	{
		title: "考前密押200题",
		paramsName: "fireSecret",
		params: "2021accountSecretyishi/firetextTypeHome/:id?",
		name: "2021accountSecretyishi/textTypeHome",
		grade: 1
	},
	{
		title: "考前密押200题",
		paramsName: "fireSecret",
		params: "2021accountSecretyishi/firetextAnswerPage/:id?",
		name: "2021accountSecretyishi/textAnswerPage",
		grade: 1
	},

	// 2021执业药师 21/9/28
	{
		title: "2021药考抢分密押题",
		paramsName: "fireSecret",
		params: "2021accountSecretzhiyeyaoshi/fireSecret/:id?",
		name: "2021accountSecretzhiyeyaoshi/fireSecretHome",
		grade: 1
	},
	{
		title: "2021药考抢分密押题",
		paramsName: "fireSecret",
		params: "2021accountSecretzhiyeyaoshi/firetextTypeHome/:id?",
		name: "2021accountSecretzhiyeyaoshi/textTypeHome",
		grade: 1
	},
	{
		title: "2021药考抢分密押题",
		paramsName: "fireSecret",
		params: "2021accountSecretzhiyeyaoshi/firetextAnswerPage/:id?",
		name: "2021accountSecretzhiyeyaoshi/textAnswerPage",
		grade: 1
	},

	// 2021一建前密押卷 08-31
	{
		title: "2021一级建造师考试临考密押题",
		paramsName: "fireSecret",
		params: "2021accountSecretyijian/fireSecret/:id?",
		name: "2021accountSecretyijian/fireSecretHome",
		grade: 1
	},
	{
		title: "2021一级建造师考试临考密押题",
		paramsName: "fireSecret",
		params: "2021accountSecretyijian/firetextTypeHome/:id?",
		name: "2021accountSecretyijian/textTypeHome",
		grade: 1
	},
	{
		title: "2021一级建造师考试临考密押题",
		paramsName: "fireSecret",
		params: "2021accountSecretyijian/firetextAnswerPage/:id?",
		name: "2021accountSecretyijian/textAnswerPage",
		grade: 1
	},
	// 2021教师密押100题 10-15
	{
		title: "2021教师密押100题",
		paramsName: "fireSecret",
		params: "2021accountSecretjiaoshi/fireSecret/:id?",
		name: "2021accountSecretjiaoshi/fireSecretHome",
		grade: 1
	},
	{
		title: "2021教师密押100题",
		paramsName: "fireSecret",
		params: "2021accountSecretjiaoshi/firetextTypeHome/:id?",
		name: "2021accountSecretjiaoshi/textTypeHome",
		grade: 1
	},
	{
		title: "2021教师密押100题",
		paramsName: "fireSecret",
		params: "2021accountSecretjiaoshi/firetextAnswerPage/:id?",
		name: "2021accountSecretjiaoshi/textAnswerPage",
		grade: 1
	},
	// 2021消防密押100题 10-18
	{
		title: "2021一级消防密押100题",
		paramsName: "fireSecret",
		params: "2021accountSecretxiaofang/fireSecret/:id?",
		name: "2021accountSecretxiaofang/fireSecretHome",
		grade: 1
	},
	{
		title: "2021一级消防密押100题",
		paramsName: "fireSecret",
		params: "2021accountSecretxiaofang/firetextTypeHome/:id?",
		name: "2021accountSecretxiaofang/textTypeHome",
		grade: 1
	},
	{
		title: "2021一级消防密押100题",
		paramsName: "fireSecret",
		params: "2021accountSecretxiaofang/firetextAnswerPage/:id?",
		name: "2021accountSecretxiaofang/textAnswerPage",
		grade: 1
	},
	// 2021二建考前密押卷
	{
		title: "考前密押200题",
		paramsName: "fireSecret",
		params: "2021accountConstructor/fireSecret/:id?",
		name: "2021accountConstructor/fireSecretHome",
		grade: 1
	},
	{
		title: "考前密押200题",
		paramsName: "fireSecret",
		params: "2021accountConstructor/firetextTypeHome/:id?",
		name: "2021accountConstructor/textTypeHome",
		grade: 1
	},
	{
		title: "考前密押200题",
		paramsName: "fireSecret",
		params: "2021accountConstructor/firetextAnswerPage/:id?",
		name: "2021accountConstructor/textAnswerPage",
		grade: 1
	},

	// 2020消防考前密押卷
	{
		title: "免费领 一消《决胜密押题》",
		paramsName: "fireSecret",
		params: "2020accountSecretxiaofang/fireSecret/:id?",
		name: "2020accountSecretxiaofang/fireSecretHome",
		grade: 1
	},
	{
		title: "免费领 一消《决胜密押题》",
		paramsName: "fireSecret",
		params: "2020accountSecretxiaofang/firetextTypeHome/:id?",
		name: "2020accountSecretxiaofang/textTypeHome",
		grade: 1
	},
	{
		title: "免费领 一消《决胜密押题》",
		paramsName: "fireSecret",
		params: "2020accountSecretxiaofang/firetextAnswerPage/:id?",
		name: "2020accountSecretxiaofang/textAnswerPage",
		grade: 1
	},

	// 2020药学职称考前密券
	{
		title: "2020药学职称-决胜密押题，每刷1题都在涨分！",
		paramsName: "fireSecret",
		params: "2020accountSecretYX/fireSecret/:id?",
		name: "2020accountSecretYX/fireSecretHome",
		grade: 1
	},
	{
		title: "2020药学职称-决胜密押题，每刷1题都在涨分！",
		paramsName: "fireSecret",
		params: "2020accountSecretYX/firetextTypeHome/:id?",
		name: "2020accountSecretYX/textTypeHome",
		grade: 1
	},
	{
		title: "2020药学职称-决胜密押题，每刷1题都在涨分！",
		paramsName: "fireSecret",
		params: "2020accountSecretYX/firetextAnswerPage/:id?",
		name: "2020accountSecretYX/textAnswerPage",
		grade: 1
	},

	// 2020建造师考前密券
	{
		title: "【押题爆料】建造师考前押题曝光，每做1题都在涨分",
		paramsName: "fireSecret",
		params: "2020architectureSecret/fireSecret/:id?",
		name: "2020architectureSecret/fireSecretHome",
		grade: 1
	},
	{
		title: "【押题爆料】建造师考前押题曝光，每做1题都在涨分",
		paramsName: "fireSecret",
		params: "2020architectureSecret/firetextTypeHome/:id?",
		name: "2020architectureSecret/textTypeHome",
		grade: 1
	},
	{
		title: "【押题爆料】建造师考前押题曝光，每做1题都在涨分",
		paramsName: "fireSecret",
		params: "2020architectureSecret/firetextAnswerPage/:id?",
		name: "2020architectureSecret/textAnswerPage",
		grade: 1
	},
	// 2019会计-考前密卷
	{
		title: "2019年中级会计",
		paramsName: "accountSecret",
		params: "accountSecret/:id?",
		name: "accountSecret/accountSecretHome",
		grade: 1
	},
	{
		title: "2019年中级会计",
		paramsName: "accountSecret",
		params: "accounttextTypeHome/:id?",
		name: "accountSecret/textTypeHome",
		grade: 1
	},
	{
		title: "做题目",
		paramsName: "accountSecret",
		params: "accounttextAnswerPage/:id?",
		name: "accountSecret/textAnswerPage",
		grade: 1
	},
	{
		title: "考点巩固",
		paramsName: "accountSecret",
		params: "accounttestConsolidate/:id?",
		name: "accountSecret/testConsolidate",
		grade: 1
	},
	{
		title: "视频跟图片题型",
		paramsName: "accountSecret",
		params: "accountspecialTypeHome/:id?",
		name: "accountSecret/specialTypeHome",
		grade: 1
	},
	{
		title: "助力解锁",
		paramsName: "accountSecret",
		params: "accountshareAssistance/:id?",
		name: "accountSecret/shareAssistance",
		grade: 1
	},
	{
		title: "抽奖",
		params: "lotteryText/:id?",
		name: "lotteryText/index",
		grade: 1
	},
	// 2019健康管理师-考前密卷
	{
		title: "执业药师资格证考试",
		paramsName: "healthSecret",
		params: "healthSecret/:id?",
		name: "healthSecret/healthSecretHome",
		grade: 1
	},
	{
		title: "执业药师资格证考试",
		paramsName: "healthSecret",
		params: "healthtextTypeHome/:id?",
		name: "healthSecret/textTypeHome",
		grade: 1
	},
	{
		title: "做题目",
		paramsName: "healthSecret",
		params: "healthtextAnswerPage/:id?",
		name: "healthSecret/textAnswerPage",
		grade: 1
	},
	{
		title: "考点巩固",
		paramsName: "healthSecret",
		params: "healthtestConsolidate/:id?",
		name: "healthSecret/testConsolidate",
		grade: 1
	},
	{
		title: "视频跟图片题型",
		paramsName: "healthSecret",
		params: "healthspecialTypeHome/:id?",
		name: "healthSecret/specialTypeHome",
		grade: 1
	},
	{
		title: "助力解锁",
		paramsName: "healthSecret",
		params: "healthshareAssistance/:id?",
		name: "healthSecret/shareAssistance",
		grade: 1
	},

	// 2019教师-考前密卷
	{
		title: "2019年教师资格考前密押100题",
		paramsName: "teacherSecret",
		params: "teacherSecret/:id?",
		name: "teacherSecret/teacherSecretHome",
		grade: 1
	},
	{
		title: "2019年教师资格考前密押100题",
		paramsName: "teacherSecret",
		params: "teachertextTypeHome/:id?",
		name: "teacherSecret/textTypeHome",
		grade: 1
	},
	{
		title: "做题目",
		paramsName: "teacherSecret",
		params: "teachertextAnswerPage/:id?",
		name: "teacherSecret/textAnswerPage",
		grade: 1
	},
	{
		title: "考点巩固",
		paramsName: "teacherSecret",
		params: "teachertestConsolidate/:id?",
		name: "teacherSecret/testConsolidate",
		grade: 1
	},
	{
		title: "视频跟图片题型",
		paramsName: "teacherSecret",
		params: "teacherspecialTypeHome/:id?",
		name: "teacherSecret/specialTypeHome",
		grade: 1
	},
	{
		title: "助力解锁",
		paramsName: "teacherSecret",
		params: "teachershareAssistance/:id?",
		name: "teacherSecret/shareAssistance",
		grade: 1
	},

	// 20191029消防-考前密卷
	{
		title: "2019一级消防考前密押100题",
		paramsName: "2019fireSecret",
		params: "2019fireSecret/:id?",
		name: "2019fireSecret/fireSecretHome",
		grade: 1
	},
	{
		title: "2019一级消防考前密押100题",
		paramsName: "2019fireSecret",
		params: "2019firetextTypeHome/:id?",
		name: "2019fireSecret/textTypeHome",
		grade: 1
	},
	{
		title: "做题目",
		paramsName: "2019fireSecret",
		params: "2019firetextAnswerPage/:id?",
		name: "2019fireSecret/textAnswerPage",
		grade: 1
	},
	{
		title: "考点巩固",
		paramsName: "2019fireSecret",
		params: "2019firetestConsolidate/:id?",
		name: "2019fireSecret/testConsolidate",
		grade: 1
	},
	{
		title: "视频跟图片题型",
		paramsName: "2019fireSecret",
		params: "2019firespecialTypeHome/:id?",
		name: "2019fireSecret/specialTypeHome",
		grade: 1
	},
	{
		title: "助力解锁",
		paramsName: "2019fireSecret",
		params: "2019fireshareAssistance/:id?",
		name: "2019fireSecret/shareAssistance",
		grade: 1
	},

	// 2019健康管理师-决胜通关卷
	{
		title: "健康管理师-决胜通关卷",
		paramsName: "2019healthSecret",
		params: "2019healthSecret/:id?",
		name: "2019healthSecret/healthSecretHome",
		grade: 1
	},
	{
		title: "健康管理师-决胜通关卷",
		paramsName: "2019healthSecret",
		params: "2019healthtextTypeHome/:id?",
		name: "2019healthSecret/textTypeHome",
		grade: 1
	},
	{
		title: "做题目",
		paramsName: "2019healthSecret",
		params: "2019healthtextAnswerPage/:id?",
		name: "2019healthSecret/textAnswerPage",
		grade: 1
	},
	{
		title: "考点巩固",
		paramsName: "2019healthSecret",
		params: "2019healthtestConsolidate/:id?",
		name: "2019healthSecret/testConsolidate",
		grade: 1
	}
];



// WEBPACK FOOTER //
// ./src/route/appRoute.js